// Refer:https://loading.io/
import React from "react";
import "./loader.css";
import LoaderGif from "./loader.gif";
import { useStore } from "../zustand/store";

const FullPageLoader = () => {
	const loading = useStore((state) => state.loading);

	return (
		loading && (
			<div className="fp-container">
				<div className="fp-loader">
					<img src={LoaderGif} alt="loading" />
				</div>
			</div>
		)
	);
};

export default FullPageLoader;
